"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var core_1 = require("@emotion/core");

var colors_1 = require("../colors");

var SPIN = core_1.keyframes(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  0% { transform: rotate(0) }\n  100% { transform: rotate(360deg) }\n"], ["\n  0% { transform: rotate(0) }\n  100% { transform: rotate(360deg) }\n"])));
var SIZE_MAP = {
  large: 90,
  medium: 64,
  small: 48,
  xsmall: 32,
  "2xsmall": 16
};
var THEME_MAP = {
  light: {
    orbitColor: colors_1.colors.silver.light,
    orbitOpacity: 1,
    asteroidColor: colors_1.colors.blue.base
  },
  dark: {
    orbitColor: colors_1.colors.white,
    orbitOpacity: 0.5,
    asteroidColor: colors_1.colors.white
  },
  grayscale: {
    orbitColor: colors_1.colors.silver.darker,
    orbitOpacity: 1,
    asteroidColor: colors_1.colors.grey.light
  }
};

exports.LoadingSpinner = function (_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? "light" : _b,
      _c = _a.size,
      size = _c === void 0 ? "medium" : _c,
      className = _a.className,
      props = tslib_1.__rest(_a, ["theme", "size", "className"]);

  var _d = THEME_MAP[theme],
      orbitColor = _d.orbitColor,
      orbitOpacity = _d.orbitOpacity,
      asteroidColor = _d.asteroidColor;
  var pixelSize = SIZE_MAP[size];
  return core_1.jsx("svg", tslib_1.__assign({
    className: className,
    viewBox: "0 0 100 100",
    css: {
      width: pixelSize,
      height: pixelSize
    }
  }, props), core_1.jsx("circle", {
    strokeWidth: "8",
    stroke: orbitColor,
    strokeOpacity: orbitOpacity,
    fill: "transparent",
    r: "41",
    cx: "50",
    cy: "50"
  }), core_1.jsx("g", {
    transform: "translate(50 50)"
  }, core_1.jsx("circle", {
    css: {
      animation: SPIN + " 540ms linear infinite",
      willChange: "transform"
    },
    fill: asteroidColor,
    r: "10",
    cx: "40",
    cy: "0"
  })));
};

var templateObject_1;